// extracted by mini-css-extract-plugin
module.exports = {"main_logo":"header-module--main_logo--2Ik1f","mini_logo":"header-module--mini_logo--1Xrg5"};